export default __webpack_public_path__ + "static/media/IF_MySalesStyle_StrengthArea_04.43fed5ef.jpg";